// GAのリンカーパラメータをダミーフォームを使って取得する
export const getLinkerParameter = (navigateLink: string) => {
  const formNode = document.createElement("form");
  formNode.action = navigateLink;
  formNode.style.opacity = "0";
  formNode.style.height = "0";
  formNode.addEventListener("submit", (event) => {
    event.preventDefault();
  });

  const buttonNode = document.createElement("button");
  buttonNode.type = "submit";

  formNode.appendChild(buttonNode);
  document.body.appendChild(formNode);

  buttonNode.click();

  const inputNode = formNode.querySelector<HTMLButtonElement>('input[name="_gl"]');

  if (inputNode) return inputNode.value;
  return "";
};
